import React from 'react';

import { Text } from '@/components/shared/element/text';
import { Grid } from '@/components/shared/layout/grid';

interface DealerPanelContentOpenHourProps {
  hourMonFri: string;
  hourSat: string;
  hourSun: string;
}

export const DealerPanelContentOpenHour: React.FunctionComponent<
  DealerPanelContentOpenHourProps
> = (props: DealerPanelContentOpenHourProps) => {
  return (
    <>
      <Grid templateColumns={{ '@xs': '2' }} columnGap="6">
        <Text as="p">วันจันทร์ – วันศุกร์</Text>
        <Text as="p">{props.hourMonFri}</Text>
      </Grid>
      <Grid templateColumns={{ '@xs': '2' }} columnGap="6">
        <Text as="p">วันเสาร์</Text>
        <Text as="p">{props.hourSat}</Text>
      </Grid>
      <Grid templateColumns={{ '@xs': '2' }} columnGap="6">
        <Text as="p">วันอาทิตย์</Text>
        <Text as="p">{props.hourSun}</Text>
      </Grid>
    </>
  );
};

DealerPanelContentOpenHour.displayName = 'SectionDealerPanelContentOpenHour';
